<template>  
<div> <!-- root element start -->

    <div  class="row">
      <div v-if="loading == 0" class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>

    <div v-if="loading == 1" class="row">

      

      <div class="col-12">
          <div class="card border-0">
            <div class="card-header h5 bg-transparent border-0">Invite User</div>
            <div class="card-body">

              <div class="row"><!--  email row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Email</span>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="form-group col-12">
                      <label class="d-none d-md-block" for="exampleInputEmail1">Email</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Email" v-model="email">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <small class="text-muted">The email listed here acts as not just the destination for emails, but also as the username for the user.</small>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                </div>
              </div>

              

              <hr class="bg-dark">

              <div class="row"><!--  role row -->
                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Role</span>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label class="d-none d-md-block" for="exampleFormControlSelect1">Role</label>
                    <select class="form-control" id="exampleFormControlSelect1" v-model="role">
                      <option value="n">Select a Role</option>
                      <option value="0">Sales Person</option>
                      <option value="1">Sales Manager</option>
                      <option value="2">Bid Manager</option>
                      <option value="3">Admin</option>

                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                </div>

              </div>

              <hr class="bg-dark">



              <div v-if="role == '0'" class="row"><!--  if user, sales manager row -->
                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Manager</span>
                </div>

                <div class="col-md-8">
                  <div class="row">

                    <div class="col-md-6">
                      <label class="d-none d-md-block" for="exampleFormControlSelect1">Select Manager</label>

                      <div class="form-group">
                        <select class="form-control" id="exampleFormControlSelect1" v-model="smAssign">
                          <option value="n">Select a Manager</option>
                          <option v-for="(sm, index) in smList" :value="sm.id">{{sm.f_name}} {{sm.l_name}}</option>
                        </select>
                      </div>

                    </div>
                
                  </div>
                  
                </div>

                <div class="col-md-2">
                </div>

              </div>

              <div class="row"><!--  status row -->
                <div class="col-md-12 text-right">
                  <button @click="submitInvite" class="btn btn-success">Submit</button>
                </div>
              </div>

            </div>
          </div>
      </div>
    </div>


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-user-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 
      loading: 1,
      smList: [],
      email: '',
      role: 'n',
      smAssign: 'n',
    }
  },
  computed: {
    prop1 () { return this.$store.state.prop1 },


  },
  watch: {
    
  },
  mounted() {
    this.getAllSMs();
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    getInviteArray() { this.$store.dispatch("getAllInvites"); },
    getAllSMs() {
      var _this = this;
      axios.get('/admin/utility/getallactivesm')
        .then(function (response) {
        var a = response.data.data;
        _this.smList = a;
      });
    },
    submitInvite() {
      var _this = this;
      var valErrors = [];
      

      if(_this.email == '' || _this.email == null) { valErrors.push("An email is required!") }
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(!_this.email.match(mailformat)) { valErrors.push("A VALID email is required!") }
      if(_this.role == '' || _this.role == null || _this.role == 'n') { valErrors.push("A role is required!") }

      if(_this.role == 0) {
        if(_this.smAssign == 'n' || _this.smAssign == '' || _this.smAssign == null) {
          valErrors.push("A user must have a sales manager assigned!")
        }
      }

      if(valErrors.length > 0) {
        var errors = valErrors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
        return false;
      }

      _this.$toastr.warning('Sending new user information.', 'Please wait!')
      axios.post('/invite',{
        email: _this.email,
        role: _this.role,
        smAssign: _this.smAssign,
      })
      .then(function (response) {
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.getInviteArray();
        _this.changeRightView('invite-list','','');
      })
      .catch(function (error) {
        var errors = error.response.data.errors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
      })
    },
    
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
